import { inject, Injectable } from '@angular/core';
import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { HttpClient, HttpParams } from '@angular/common/http';
import { NOTIFICATIONS_API_BASE_URL } from '../../api-base-url.token';

@Injectable({ providedIn: 'root' })
export class NotificationsUtilityApi {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(NOTIFICATIONS_API_BASE_URL)}/utility/notifications`;

    read(id: string, readKey: string) {
        return this.builder
            .url(`${this.controllerUrl}/Read`)
            .get()
            .text()
            .withHttpParams(new HttpParams().set('id', id).set('readKey', readKey))
            .build()
            .send();
    }
}
